<template>
  <div>
    <SampleSearchForm :listForm="searchList" @handlerSearch="onSearch" />
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      :showCheckbox="false"
      @page-size-change="pageSizeChange"
    >
      <template #idSlot="{ row }">
        <div class="cml-sample-info-capacity">
          <el-image
            v-if="row.mainImage" 
            style="width: 50px; height: 50px; margin-right: 5px;"
            :src="row.mainImage + $ImgQuality30"
            :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
            fit="contain"
          >
            <div slot="placeholder" class="sample-image-slot">
              加载中
            </div>
          </el-image>
          <div>
            <p>产品ID：{{ row.productId }} </p>
            <span>{{ row.productName }} </span>
            <div v-if="row.capacity">
              容量：{{ row.capacity }}{{ row.unit }}
            </div>
          </div>
        </div>
      </template>
      <!-- 采用结果 -->
      <template #isUseSlot="{ row }">
        <div>
          <span>
            {{ row.isUse ? (row.isUse === 'YES' ? '采用' : '不采用') : '' }}
          </span>
          <el-tooltip
            v-if="row.reason"
            effect="dark"
            :content="row.reason"
            placement="top"
          >
            <span class="sample-btn">查看原因</span>
          </el-tooltip>
        </div>
      </template>
      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="showDetail(row)">{{
          row.code
        }}</span>
      </template>
    </CommonTable>
    <!-- 详情弹窗 -->
    <SampleOperationLogDialog ref="sampleOperationLogDialog" :listData="listData" />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import SampleOperationLogDialog from '@/components/SampleOperationLogDialog';
export default {
  components: { CommonTable, SampleSearchForm, SampleOperationLogDialog },
  props: {
    addBtn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品ID',
            prop: 'productId',
            defaultValue: undefined,
            placeholder: '请输入完整产品ID',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          }
        ],
      },
      listForm: { type:  2 },
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableHeadTab: [
        {
          label: '产品信息',
          prop: 'id',
          slotColumn: true,
          slotName: 'idSlot',
          width: 200,
        },
        {
          label: '寻样单编号',
          prop: 'code',
          width: 140,
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', width: 140 },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'orderUnit', width: 80 },
        { label: '样品类型', prop: 'sampleTypeName', width: 80 },
        { label: '供应商', prop: 'supplierName' },
        { label: '申请人', prop: 'demandStaffName', width: 100 },
        { label: '需求品牌', prop: 'demandBrandName', width: 100 },
        { label: '用途', prop: 'purpose' },
        { label: '审批结果', prop: 'leaderStatusName', width: 100 }
      ],
      tableDataTab: {},
      listData: {}
    };
  },
  computed: {},
  mounted() {
    this.getList();
    this.$refs.CommonTable.changeHeight();
  },
  methods: {
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.sample
        .getOrderLeadInfo(params)
        .then(result => {
          this.tableDataTab = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    showDetail(row) {
      this.$refs.sampleOperationLogDialog.dialogVisible = true;
      this.listData = {
        supplierName: row.supplierName,
        list: [row],
      };
    }
  },
};
</script>

<style lang="less" scoped>
.sample-btn {
  cursor: pointer;
  color: #AB0033;
  margin: 0 7px;
}
</style>
